import { createTypes, createAction } from 'lib/action'

const LOAD_SCCO_WEBSERVICE_LOG = createTypes('sccowebservicelog', 'load')
const REMOVE_LISTS = 'REMOVE_SCCO_WEBSERVICE_LOG_LISTS'

const SEARCH_SCCO_MASTER = createTypes('sccolog', 'searchmaster')
const CLEAR_MASTER_SEARCH = 'CLEAR_SCCO_MASTER_SEARCH'

const LOAD_SCCO_SERVICE_NAMES = createTypes('sccolog', 'servicenames')

const loadSccoWebserviceLog = {
  request: (data, loading) =>
    createAction(LOAD_SCCO_WEBSERVICE_LOG.REQUEST, { data, loading }),
  success: lists =>
    createAction(LOAD_SCCO_WEBSERVICE_LOG.SUCCESS, { lists }),
  failure: () => createAction(LOAD_SCCO_WEBSERVICE_LOG.FAILURE),
}

const removeLists = () => ({ type: REMOVE_LISTS })

const searchSccoMaster = {
  request: (data, loading) =>
    createAction(SEARCH_SCCO_MASTER.REQUEST, { data, loading }),
  success: lists =>
    createAction(SEARCH_SCCO_MASTER.SUCCESS, { lists }),
  failure: () => createAction(SEARCH_SCCO_MASTER.FAILURE),
}

const clearMasterSearch = () => ({ type: CLEAR_MASTER_SEARCH })

const loadSccoServiceNames = {
  request: data => createAction(LOAD_SCCO_SERVICE_NAMES.REQUEST, { data }),
  success: list => createAction(LOAD_SCCO_SERVICE_NAMES.SUCCESS, { list }),
  failure: () => createAction(LOAD_SCCO_SERVICE_NAMES.FAILURE),
}

const LOAD_RELATED_TRUCKS = createTypes('sccolog', 'relatedtrucks')

const loadRelatedTrucks = {
  request: data => createAction(LOAD_RELATED_TRUCKS.REQUEST, { data }),
  success: list => createAction(LOAD_RELATED_TRUCKS.SUCCESS, { list }),
  failure: () => createAction(LOAD_RELATED_TRUCKS.FAILURE),
}

export {
  LOAD_SCCO_WEBSERVICE_LOG,
  loadSccoWebserviceLog,
  REMOVE_LISTS,
  removeLists,
  SEARCH_SCCO_MASTER,
  searchSccoMaster,
  CLEAR_MASTER_SEARCH,
  clearMasterSearch,
  LOAD_SCCO_SERVICE_NAMES,
  loadSccoServiceNames,
  LOAD_RELATED_TRUCKS,
  loadRelatedTrucks,
}
